/* eslint-disable array-callback-return */
/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Link } from "react-router-dom";
import isEmpty from "../../../validation/isEmpty";

const UserList = ({ parentIndex, dailyCanteen, values }) => {
  return (
    <tr style={{ fontSize: "12px" }}>
      <td>{parentIndex + 1}</td>
      <td>
        {!isEmpty(dailyCanteen.Date)
          ? moment(dailyCanteen.Date).format("DD-MM-yyyy")
          : moment(values.date).format("DD-MM-yyyy")}
      </td>
      <td>
        <Link to={`/hr/user/all-users/${dailyCanteen.employeeId}`}>
          {dailyCanteen.workerFullName}
        </Link>
      </td>
      <td>{dailyCanteen.workerId}</td>
      <td className="text-center">{dailyCanteen?.breakFastTime}</td>
      <td className="text-center">{dailyCanteen?.lunchTime}</td>
      <td className="text-center">{dailyCanteen?.dinnerTime}</td>

      {!isEmpty(dailyCanteen?.dataArray) &&
        dailyCanteen.dataArray.map(
          (dynamicValue, dynamicValueIndex) => (
            <td key={dynamicValueIndex}>
              {dynamicValue.label === "Detection Image"
                ? !isEmpty(dailyCanteen.detectionImages) &&
                  dailyCanteen?.detectionImages.map(
                    (imageId, imageIdIndex) => (
                      <strong key={imageIdIndex}>
                        <img
                          src={imageId}
                          height="50"
                          width="50"
                          alt="File not found Image"
                        />

                        {/* <a
                          href={imageId}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ fontSize: 10 }}
                        >
                          Img {imageIdIndex + 1},
                        </a> */}
                      </strong>
                    )
                  )
                : dynamicValue?.value || ""}
            </td>
          )
        )}
    </tr>
  );
};

UserList.propTypes = {
  dailyCanteen: PropTypes.object,
  values: PropTypes.object,
  parentIndex: PropTypes.any
};

export default UserList;
